import React from "react";
import { HandCoins, Loader2 } from "lucide-react";
import { formatter } from "~/functions";

export default function BalancePanel({
  balance,
  loading = false,
  canLaunchFee = true,
  onLaunchFee = () => null,
  onRemoveFee = () => null,
  hasFee = false,
}) {
  if (loading || !balance) {
    return (
      <div className="w-full border rounded-xl p-4 flex flex-row items-center justify-center gap-2 text-xs text-gray-500">
        <Loader2 size={16} className="animate-spin" /> Loading balance...
      </div>
    );
  }

  const difference = Number(balance.difference || 0);
  const isZero = Math.abs(difference) < 0.005;

  const Line = ({ title, value, className = "", children = null }) => (
    <div className="flex flex-row items-center justify-between w-full gap-4">
      <span className={`text-gray-500 ${className}`}>{title}</span>
      <div className="flex flex-row items-center justify-end gap-2">
        <span className={`font-bold ${className}`}>{formatter.format(value || 0)}</span>
        {children}
      </div>
    </div>
  );

  return (
    <div className="w-full border rounded-xl p-4 flex flex-col items-start justify-start gap-2 text-xs">
      <Line title="Gross" value={balance.batch_amount} />
      <Line title="Conciliated" value={balance.conciliated_amount} />
      <Line title="Fee" value={balance.fee_amount}>
        {canLaunchFee ? (
          hasFee ? (
            <button
              type="button"
              onClick={onRemoveFee}
              className="border border-red-500 text-red-500 rounded-md px-2 py-1 flex flex-row items-center justify-center gap-1 hover:bg-red-500 hover:text-white transition-all"
            >
              Remove fee
            </button>
          ) : (
            <button
              type="button"
              onClick={onLaunchFee}
              className="bg-primary text-white rounded-md px-2 py-1 flex flex-row items-center justify-center gap-1 hover:opacity-80 transition-all"
            >
              <HandCoins size={14} /> Launch fee
            </button>
          )
        ) : null}
      </Line>

      <div className="w-full border-b my-1" />

      <Line title="Deposit" value={balance.expected_deposit} />
      <Line
        title="Difference"
        value={difference}
        className={isZero ? "text-emerald-600" : "text-red-600"}
      />

      <div className="w-full flex flex-row items-center justify-between text-gray-500 pt-2">
        <span>
          {balance.verified_items || 0}/{balance.total_items || 0} items verified
        </span>
        <span>{balance.pending_items || 0} pending</span>
      </div>
    </div>
  );
}
